export const getDefaultState = () => {
  return {
    demo: null
  }
}

const state = getDefaultState()
export default state
